import { getRequest } from '@/core';
import { globalAddresses } from '@/requests';

export default async function getAllGlobalAddressesRequest() {
	let url = globalAddresses.getAllPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
